module.exports = __webpack_public_path__ + "media/intro_600x600.75271624.mp4";